module.exports = __webpack_public_path__ + "static/media/toggle.67e26bc5.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/static/toggle.gif
// module id = 376
// module chunks = 39